const Home = () => import('@/components/Home')
const SaaS = () => import('@/components/SaaS')
const Login = () => import('@/components/Auth/Login')
const CodeLogin = () => import('@/components/Auth/CodeLogin')
const Register = () => import('@/components/Auth/Reg')
const FranReg = () => import('@/components/Auth/FranReg')
const OtherReg = () => import('@/components/Auth/OtherReg')
const Rest = () => import('@/components/Auth/Rest')
const TalkLogin = () => import('@/components/Auth/TalkLogin')
const Index = () => import('@/components/Index/Index')
const LearnContainer = () => import('@/components/Learn/Container')
const Chat = () => import('@/components/Chat/Index')
const Learn = () => import('@/components/Learn/Index')
const InfoDetail = () => import('@/components/Learn/InfoDetail')
const MyClass = () => import('@/components/Learn/MyClass')
const Personal = () => import('@/components/Learn/Personal')
const ClassDetail = () => import('@/components/Learn/ClassDetail')
const Report = () => import('@/components/Learn/Report')
const LearnOrder = () => import('@/components/Learn/Order')
const Practice = () => import('@/components/Learn/Practice')
const Buy = () => import('@/components/Learn/Buy')
const ChangeDetail = () => import('@/components/Learn/ChangeDetail')
const Exchange = () => import('@/components/Learn/Exchange')
const Success = () => import('@/components/Learn/Success')
const SureOrder = () => import('@/components/Learn/SureOrder')
const RedeemCode = () => import('@/components/Learn/RedeemCode')
const ScheduleDetail = () => import('@/components/Learn/ScheduleDetail')
const Message = () => import('@/components/Message/Index')
const MsgDetail = () => import('@/components/Message/Detail')
const FeedbackDetail = () => import('@/components/Message/FeedbackDetail')
const Course = () => import('@/components/Course/Index')
const CourseDetail = () => import('@/components/Course/Detail')
const CourseDiscount = () => import('@/components/Course/Discount')
const CourseBuy = () => import('@/components/Course/Buy')
const CoursePromotion = () => import('@/components/Course/Promotion')
const CourseFail = () => import('@/components/Course/Fail')
const CourseEvaluation = () => import('@/components/Course/Evaluation')
const CourseQuestions = () => import('@/components/Course/Questions')
const CourseQuestion = () => import('@/components/Course/Question')
const CourseScore = () => import('@/components/Course/Score')
const Teather = () => import('@/components/Teather/Index')
const Note = () => import('@/components/Teather/Note')
const AssessEvaluation = () => import('@/components/Assess/Evaluation')
const AssessQuestions = () => import('@/components/Assess/Questions')
const AssessQuestionsExpire = () => import('@/components/Assess/QuestionsExpire')
const AssessResult = () => import('@/components/Assess/Result')
const CourseIntroduce = () => import('@/components/CourseIntroduce/Index')
const Download = () => import('@/components/Download/Index')
const Toclass = () => import('@/components/Public/Toclass')
const Test = () => import('@/components/Public/Test')
const Contact = () => import('@/components/Help/Contact')
const Problem = () => import('@/components/Help/Problem')
const Groupon = () => import('@/components/Groupon/Index')
const GrouponOrder = () => import('@/components/Groupon/Order')
const GrouponSuccess = () => import('@/components/Groupon/Success')
const Article = () => import('@/components/Learn/Article')
const Extension = () => import('@/components/Public/Extension')
const InviteFriends = () => import('@/components/Public/InviteFriends')
const SubjectiveResult = () => import('@/components/Subjective/Result')
const SubjectiveEvaluation = () => import('@/components/Subjective/Evaluation')
const SubjectiveEvaluationExpire = () => import('@/components/Subjective/EvaluationExpire')
const TeacherCertification = () => import('@/components/Public/TeacherCertification')
const RecordVideo = () => import('@/components/Learn/RecordVideo')
const HeadlineDetail = () => import('@/components/Headline/Detail')
const HeadlineCollect = () => import('@/components/Headline/Collect')
const FilePreview = () => import('@/components/Public/FilePreview')
const MyHeadline = () => import('@/components/Headline/My')
const HeadlineAdd = () => import('@/components/Headline/Add')
const HeadlinePreview = () => import('@/components/Headline/Preview')
const News = () => import('@/components/News/Index')
const Join = () => import('@/components/Join/Index')
const MyCoupon = () => import('@/components/Learn/MyCoupon')
const Equity = () => import('@/components/Public/Equity')
const CouponCourse = () => import('@/components/Public/CouponCourse')
const VipCourse = () => import('@/components/Public/VipCourse')
const DiscountCourse = () => import('@/components/Public/DiscountCourse')
const Ranking = () => import('@/components/Ranking/Index')
const HeadlinePlate = () => import('@/components/Headline/Plate')

let routers = [{
  path: '*',
  redirect: '/index'
}, {
  path: '/',
  redirect: '/index',
  component: Home
}, {
  path: '/file/preview/:id',
  component: FilePreview,
  name: 'FilePreview'
}, {
  path: '/SaaS',
  component: SaaS,
  name: 'SaaS'
}, {
  path: '/login',
  component: Login,
  name: 'Login'
}, {
  path: '/codelogin',
  component: CodeLogin,
  name: 'CodeLogin'
}, {
  path: '/register',
  component: Register,
  name: 'Register'
}, {
  path: '/franchise/reg/:id',
  component: FranReg,
  name: 'FranReg'
}, {
  path: '/otherReg',
  component: OtherReg,
  name: 'OtherReg'
}, {
  path: '/rest',
  component: Rest,
  name: 'Rest'
}, {
  path: '/talk/login',
  component: TalkLogin,
  name: 'TalkLogin'
}, {
  path: '/extension',
  component: Extension,
  name: 'Extension'
}, { // 邀请奖励ArchivesExamineSheet
  path: '/invite',
  component: InviteFriends,
  name: 'InviteFriends'
}, { // 学习大厅 - 个人档案 -领导评分
  path: '/archives/scoreSheet/:id',
  component: resolve => require(['@/components/Archives/ScoreSheet'], resolve),
  name: 'ArchivesScoreSheet'
}, { // 学习大厅 - 个人档案 -表格填写
  path: '/archives/sheetFill/:id',
  component: resolve => require(['@/components/Archives/SheetFill'], resolve),
  name: 'ArchivesSheetFill'
}, { // 学习大厅 - 周报
  path: '/log',
  component: resolve => require(['@/components/Log/Index'], resolve),
  name: 'Log'
}, { // 头条号 - 新增文章
  path: '/headline/add',
  component: HeadlineAdd,
  name: 'HeadlineAdd',
  meta: {
    parent: 'index',
    menu: '3'
  }
}, { // 招商加盟
  path: '/join',
  component: Join,
  name: 'Join',
  meta: {
    parent: 'join',
    menu: '8'
  }
}, { // 头条号 - 预览文章
  path: '/headline/preview',
  component: HeadlinePreview,
  name: 'HeadlinePreview',
  meta: {
    parent: 'index',
    menu: '3'
  }
}, { // 学习大厅 - 消息中心
  path: '/chat',
  component: Chat,
  name: 'Chat',
  meta: {
    // 不获取机构信息
    noGetSaasInfo: true
  }
}, { // 首页
  path: '/index',
  component: Home,
  children: [{ // 首页
    path: '/index',
    component: Index,
    name: 'Index',
    meta: {
      parent: 'index',
      menu: '1',
      keepAlive: true
    }
  }, { // 课程中心
    path: '/course',
    component: Course,
    name: 'Course',
    meta: {
      parent: 'course',
      menu: '2',
      keepAlive: true
    }
  }, { // 课程详情
    path: '/course/detail/:id/:sid',
    component: CourseDetail,
    name: 'CourseDetail',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 热点资讯
    path: '/news',
    component: News,
    name: 'News',
    meta: {
      parent: 'news',
      menu: '7',
      keepAlive: true
    }
  }, { // 优惠联报
    path: '/course/discount/:id',
    component: CourseDiscount,
    name: 'CourseDiscount',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 购买课程
    path: '/course/buy/:id/:sid',
    component: CourseBuy,
    name: 'CourseBuy',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 购买促销课程
    path: '/course/promotion/:id',
    component: CoursePromotion,
    name: 'CoursePromotion',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 购买失败
    path: '/course/fail',
    component: CourseFail,
    name: 'CourseFail',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 测评标题
    path: '/course/evaluation/:id/:bid',
    component: CourseEvaluation,
    name: 'CourseEvaluation',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 测评题
    path: '/course/questions/:id/:bid',
    component: CourseQuestions,
    name: 'CourseQuestions',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 联报测评题
    path: '/course/question/:id/:bid/:cid',
    component: CourseQuestion,
    name: 'CourseQuestion',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 测评得分
    path: '/course/score',
    component: CourseScore,
    name: 'CourseScore',
    meta: {
      parent: 'course',
      menu: '2'
    }
  }, { // 老师详情
    path: '/teather/:id',
    component: Teather,
    name: 'Teather',
    meta: {
      parent: 'teather',
      menu: '5'
    }
  }, { // 帖子详情
    path: '/teather/note/:id',
    component: Note,
    name: 'Note',
    meta: {
      parent: 'teather',
      menu: '2'
    }
  }, { // 课后测评标题
    path: '/assess/evaluation',
    component: AssessEvaluation,
    name: 'AssessEvaluation',
    meta: {
      parent: 'assess',
      menu: '3'
    }
  }, { // 课后测评
    path: '/assess/questions/:id/:bid',
    component: AssessQuestions,
    name: 'AssessQuestions',
    meta: {
      parent: 'assess',
      menu: '3'
    }
  }, { // 课后测评-过期
    path: '/assess/questions/expire/:id/:bid',
    component: AssessQuestionsExpire,
    name: 'AssessQuestionsExpire',
    meta: {
      parent: 'assess',
      menu: '3'
    }
  }, { // 课后测评结果
    path: '/assess/result/:id/:eid',
    component: AssessResult,
    name: 'AssessResult',
    meta: {
      parent: 'assess',
      menu: '3'
    }
  }, { // 主观题课后测评
    path: '/subjective/evaluation/:id/:bid',
    component: SubjectiveEvaluation,
    name: 'SubjectiveEvaluation',
    meta: {
      parent: 'assess',
      menu: '3'
    }
  }, { // 主观题课后测评-过期
    path: '/subjective/evaluation/expire/:id/:bid',
    component: SubjectiveEvaluationExpire,
    name: 'SubjectiveEvaluationExpire',
    meta: {
      parent: 'assess',
      menu: '3'
    }
  }, { // 主观题课后测评结果
    path: '/subjective/result/:id/:bid',
    component: SubjectiveResult,
    name: 'SubjectiveResult',
    meta: {
      parent: 'assess',
      menu: '3'
    }
  }, { // 学习大厅 - 容器
    path: '/learn',
    component: LearnContainer,
    name: 'LearnContainer',
    meta: {
      isAuth: true
      // keepAlive: true
    },
    children: [{ // 学习大厅 - 首页
      path: '/learn',
      component: Learn,
      name: 'Learn',
      meta: {
        isAuth: true,
        parent: 'Learn',
        menu: '3'
      }
    }, { // 学习大厅 - 已购课程
      path: '/myclass',
      component: MyClass,
      name: 'MyClass',
      meta: {
        isAuth: true,
        parent: 'MyClass',
        menu: '3'
      }
    }, { // 学习大厅 - 个人资料
      path: '/personal',
      component: Personal,
      name: 'Personal',
      meta: {
        isAuth: true,
        parent: 'Personal',
        menu: '3'
      }
    }, { // 学习大厅 - 课后练习
      path: '/learn/practice',
      component: Practice,
      name: 'Practice',
      meta: {
        isAuth: true,
        parent: 'Practice',
        menu: '3',
        keepAlive: true
      }
    }, { // 学习大厅 - 订单详情
      path: '/learn/order',
      component: LearnOrder,
      name: 'LearnOrder',
      meta: {
        isAuth: true,
        parent: 'LearnOrder',
        menu: '3',
        keepAlive: true
      }
    }, { // 学习大厅 - 兑换码
      path: '/redeemcode',
      component: RedeemCode,
      name: 'RedeemCode',
      meta: {
        isAuth: true,
        parent: 'RedeemCode',
        menu: '3'
      }
    }, { // 学习大厅 - 我的文章
      path: '/headline/my',
      component: MyHeadline,
      name: 'MyHeadline',
      meta: {
        isAuth: true,
        parent: 'MyHeadline',
        menu: '3'
      }
    }, { // 学习大厅 - 我的优惠券
      path: '/mycoupon',
      component: MyCoupon,
      name: 'MyCoupon',
      meta: {
        isAuth: true,
        parent: 'MyCoupon',
        menu: '3'
      }
    }, { // 学习大厅 - 通知与反馈
      path: '/message',
      component: Message,
      name: 'Message',
      meta: {
        isAuth: true,
        parent: 'message',
        menu: '3',
        keepAlive: true
      }
    }, { // 学习大厅 - 个人档案
      path: '/archives',
      component: resolve => require(['@/components/Archives/Index'], resolve),
      name: 'Archives',
      meta: {
        isAuth: true,
        parent: 'archives',
        menu: '3',
        keepAlive: true
      }
    }]
  }, { // 学习大厅 - 已购课程 - 课程详情
    path: '/myclass/classdetail/:courseScheduleId/:sellCourseScheduleId/:mStatus',
    component: ClassDetail,
    name: 'ClassDetail',
    meta: {
      isAuth: true,
      parent: 'classdetail',
      menu: '3'
    }
  }, { // 学习大厅 - 已购课程 - 学情报告
    path: '/myclass/report/:courseScheduleId/:sellCourseScheduleId',
    component: Report,
    name: 'Report',
    meta: {
      isAuth: true,
      parent: 'report',
      menu: '3'
    }
  }, { // 学习大厅 - 购买学豆
    path: '/buy',
    component: Buy,
    name: 'Buy',
    meta: {
      isAuth: true,
      parent: 'Buy',
      menu: '3'
    }
  }, { // 学习大厅 - 学豆详情
    path: '/changedetail',
    component: ChangeDetail,
    name: 'ChangeDetail',
    meta: {
      isAuth: true,
      parent: 'changedetail',
      menu: '3'
    }
  }, { // 学习大厅 - 兑换学豆
    path: '/exchange',
    component: Exchange,
    name: 'Exchange',
    meta: {
      isAuth: true,
      parent: 'Exchange',
      menu: '3'
    }
  }, { // 学习大厅 - 公告详情
    path: '/infodetail/:id',
    component: InfoDetail,
    name: 'InfoDetail',
    meta: {
      isAuth: true,
      parent: 'infodetail',
      menu: '3'
    }
  }, { // 学习大厅 - 兑换学豆 - 成功
    path: '/exchange/success/:num',
    component: Success,
    name: 'Success',
    meta: {
      isAuth: true,
      parent: 'success',
      menu: '3'
    }
  }, { // 学习大厅 - 兑换学豆 - 订单详情
    path: '/sureorder/:orderId/:orderNum/:id',
    component: SureOrder,
    name: 'SureOrder',
    meta: {
      isAuth: true,
      parent: 'sureorder',
      menu: '3'
    }
  }, { // 学习大厅 - 课表详情
    path: '/learn/scheduledetail/:id/:courseStatus/:classType',
    component: ScheduleDetail,
    name: 'ScheduleDetail',
    meta: {
      isAuth: true,
      parent: 'ScheduleDetail',
      menu: '3'
    }
  }, { // 消息中心 - 详情
    path: '/message/detail/:id',
    component: MsgDetail,
    name: 'MsgDetail',
    meta: {
      isAuth: true,
      parent: 'message'
    }
  }, { // 消息中心 - 详情
    path: '/feedback/detail/:id',
    component: FeedbackDetail,
    name: 'FeedbackDetail',
    meta: {
      isAuth: true,
      parent: 'message'
    }
  }, { // 课程介绍
    path: '/courseintroduce',
    component: CourseIntroduce,
    name: 'CourseIntroduce',
    meta: {
      parent: 'courseintroduce',
      menu: '4'
    }
  }, { // 下载
    path: '/download',
    component: Download,
    name: 'Download',
    meta: {
      parent: 'download',
      menu: '6'
    }
  }, { // 进入教室
    path: '/toclass',
    component: Toclass,
    name: 'Toclass'
  }, { // 检测设备
    path: '/test',
    component: Test,
    name: 'Test'
  }, { // 联系我们
    path: '/contact/:id',
    component: Contact,
    name: 'Contact',
    meta: {
      parent: 'contact',
      menu: '9'
    }
  }, { // 常见问题
    path: '/problem/:id',
    component: Problem,
    name: 'Problem'
  }, { // 团购
    path: '/groupon/:id',
    component: Groupon,
    name: 'Groupon'
  }, { // 团购
    path: '/groupon/order/:id',
    component: GrouponOrder,
    name: 'GrouponOrder'
  }, { // 团购成功
    path: '/groupon/success/:id',
    component: GrouponSuccess,
    name: 'GrouponSuccess'
  }, { // 发布文章
    path: '/article/add',
    component: Article,
    name: 'Article'
  }, { // 教师资格证
    path: '/teacher/certification',
    component: TeacherCertification,
    name: 'TeacherCertification',
    meta: {
      parent: 'certification',
      menu: '5'
    }
  }, { // 录播课观看
    path: '/learn/recordVideo/:sellCourseId',
    component: RecordVideo,
    name: 'RecordVideo'
  }, { // 头条号 - 详情
    path: '/headline/detail/:id',
    component: HeadlineDetail,
    name: 'HeadlineDetail',
    meta: {
      parent: 'index',
      menu: '1'
    },
    beforeEnter: (to, from, next) => {
      console.log('from', from)
      if (to.query.fromName === 'MyHeadline') {
        // 来自我的文章 菜单定位到“学习大厅”
        to.meta.menu = '3'
      } else if (to.query.fromName === 'News') {
        // 来自热点资讯页面，菜单定位到“热点资讯”
        to.meta.menu = '7'
      } else if (to.query.fromName === 'HeadlinePlate') {
        // 来自独立板块，菜单定位到“独立板块”
        to.meta.menu = '10'
      }
      next()
    }
  }, { // 头条号 - 我的点赞/我的收藏
    path: '/headline/collect',
    component: HeadlineCollect,
    name: 'HeadlineCollect',
    meta: {
      parent: 'index',
      menu: '1'
    }
  }, { // 会员权益
    path: '/equity',
    component: Equity,
    name: 'Equity'
  }, { // 优惠券适配课程
    path: '/coupon/course',
    component: CouponCourse,
    name: 'CouponCourse'
  }, { // 会员课程
    path: '/vip/course',
    component: VipCourse,
    name: 'VipCourse'
  }, { // 会员折扣课程
    path: '/discount/course',
    component: DiscountCourse,
    name: 'DiscountCourse'
  }, { // 榜单
    path: '/ranking',
    component: Ranking,
    name: 'Ranking'
  }, { // 头条号 - 独立板块
    path: '/headline/plate',
    component: HeadlinePlate,
    name: 'HeadlinePlate',
    meta: {
      parent: 'index',
      menu: '10'
    }
  }]
}]

export default routers



// WEBPACK FOOTER //
// ./src/router/general.js